import html2canvas from "html2canvas";
import JsPDF from "jspdf";
export default {
  install(Vue, options) {
    Vue.prototype.getPdf = function (id, title) {
      html2canvas(document.querySelector(`#${id}`), {
        allowTaint: true,
        scale: 1,
        height: document.getElementById(id).scrollHeight,
        windowHeight: document.getElementById(id).scrollHeight
      }).then(function (canvas) {
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        let pageHeight = contentWidth / 841.89 * 592.28
        let leftHeight = contentHeight
        let position = 0
        let imgWidth = 841.89
        let imgHeight = 841.89 / contentWidth * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        let PDF = new JsPDF('l', 'pt', 'a4')
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 592.28
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        PDF.save(title + '.pdf')
      })
    }
  }
}